export class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.type = 'timeout';
        this.name = 'TimeoutError';
        Object.setPrototypeOf(this, TimeoutError.prototype);
    }
}
export const withTimeout = (wrappedFetch, timeoutOptions, context) => (input, options) => {
    const { timeout: timeoutMS } = timeoutOptions;
    const pendingRequest = wrappedFetch(input, options);
    if (!timeoutMS) {
        return pendingRequest;
    }
    return new Promise((res, rej) => {
        setTimeout(() => {
            const reason = new TimeoutError(`Operation timed out after ${timeoutMS}ms`);
            if (context.abortController) {
                context.abortController.abort(reason);
            }
            else {
                rej(reason);
            }
        }, timeoutMS);
        return pendingRequest.then(res, rej);
    });
};
//# sourceMappingURL=timeout.js.map